import Barba from 'barba.js';
window.Barba = Barba;
